import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

import './i18n';
import './App.css';

import { GlobalStyle } from './globalStyle';
import { postMessage } from './utils';
import { PATHS } from './config';
import Header from './components/header';
import ContestForm from './components/contest-form';
import FormCompleted from './components/form-completed';
// import CountryModal from './components/country-modal';
import CompetitionClosed from './components/competition-closed';

const App = () => {
  const { FORM, COMPLETED, CLOSED } = PATHS;
  return (
    <div className="App">
      <Suspense fallback={<div></div>}>
        <GlobalStyle />
        <ToastContainer position="bottom-left" />
        <Header />
        {/* <CountryModal /> */}
        <Routes>
          <Route path=":lang" element={<Outlet />}>
            <Route index element={<CompetitionClosed />} />
            <Route path={CLOSED} element={<CompetitionClosed />} />
            {/* <Route path={FORM} element={<ContestForm />} /> */}
            <Route path={COMPLETED} element={<FormCompleted />} />
            <Route path="*" element={<Navigate to={CLOSED} />} />
          </Route>
          <Route path={`ce/${FORM}`} element={<ContestForm />} />
          <Route path="*" element={<Navigate to={CLOSED} />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;

function onElementHeightChange(elm, callback) {
  var lastHeight = elm.clientHeight,
    newHeight;

  (function run() {
    newHeight = elm.clientHeight;
    if (lastHeight !== newHeight) callback(newHeight);
    lastHeight = newHeight;

    if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer);

    elm.onElementHeightChangeTimer = setTimeout(run, 200);
  })();
}

onElementHeightChange(document.body, function () {
  postMessage('resize', { height: document.body.clientHeight });
});
